<!--Request Type dropdown-->
<div *ngIf="column.regDropdown" class="filterheight overflow-auto">
  
    <ul class="list-group">
      <li class="list-group-item filter-header">Filters</li> 
      <li class="list-group-item">
        <span>
          <span class="icon-ic_checkbox" *ngIf="selectAllRegType.isChecked"
            (click)="selectAllRegType.isChecked = false;selectAllRegTypeFilter(selectAllRegType.isChecked)"></span>
          <span class="icon-ic_checkbox_all" *ngIf="!selectAllRegType.isChecked"
            (click)="selectAllRegType.isChecked = true;selectAllRegTypeFilter(selectAllRegType.isChecked)"></span>
          <span class="ml-2"
            (click)="selectAllRegType.isChecked = !selectAllRegType.isChecked; selectAllRegTypeFilter(selectAllRegType.isChecked)">All</span>
        </span>
      </li>
      <li class="list-group-item" *ngFor="let tyarray of registrationArray">
        <span>
          <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(registrationArray,selectAllRegType,tyarray.isCheck)"></span>
          <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(registrationArray,selectAllRegType,tyarray.isCheck)"></span>
          <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(registrationArray,selectAllRegType,tyarray.isCheck)">{{tyarray.description}}</span>
        </span>
      </li>
    </ul>
  </div>

  <!-- Status Dropdown -->
  <div *ngIf="column.statusDropdown" class="filterheight overflow-auto">
          
      <ul class="list-group"> 
          <li class="list-group-item filter-header">Filters</li> 
          <li class="list-group-item">
              <span>
                  <span class="icon-ic_checkbox" *ngIf="selectAllStatusType.isChecked" (click)="selectAllStatusType.isChecked = false;selectAllStatusFilter(selectAllStatusType.isChecked)"></span>
                  <span class="icon-ic_checkbox_all" *ngIf="!selectAllStatusType.isChecked" (click)="selectAllStatusType.isChecked = true;selectAllStatusFilter(selectAllStatusType.isChecked)"></span>
                  <span class="ml-2" (click)="selectAllStatusType.isChecked = !selectAllStatusType.isChecked; selectAllStatusFilter(selectAllStatusType.isChecked)">All</span>
              </span>
          </li>
          <li class="list-group-item" *ngFor="let tyarray of statusArray">
              <span class="csr">
                  <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(statusArray,selectAllStatusType,tyarray.isCheck)"></span>
                  <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(statusArray,selectAllStatusType,tyarray.isCheck)"></span>
                  <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(statusArray,selectAllStatusType,tyarray.isCheck)">{{tyarray.description}}</span>
              </span>
          </li>
      </ul>
  </div>
  
  <!-- Brought From Dropdown -->
  <div *ngIf="column.brfromDropdown" class="filterheight overflow-auto">
          
      <ul class="list-group"> 
          <li class="list-group-item filter-header">Filters</li> 
          <li class="list-group-item">
              <span>
                  <span class="icon-ic_checkbox" *ngIf="selectAllFromType.isChecked" (click)="selectAllFromType.isChecked = false;selectAllFromFilter(selectAllFromType.isChecked)"></span>
                  <span class="icon-ic_checkbox_all" *ngIf="!selectAllFromType.isChecked" (click)="selectAllFromType.isChecked = true;selectAllFromFilter(selectAllFromType.isChecked)"></span>
                  <span class="ml-2" (click)="selectAllFromType.isChecked = !selectAllFromType.isChecked; selectAllFromFilter(selectAllFromType.isChecked)">All</span>
              </span>
          </li>
          <li class="list-group-item" *ngFor="let tyarray of brfromArray">
              <span class="csr">
                  <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(brfromArray,selectAllFromType,tyarray.isCheck)"></span>
                  <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(brfromArray,selectAllFromType,tyarray.isCheck)"></span>
                  <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(brfromArray,selectAllFromType,tyarray.isCheck)">{{tyarray.description}}</span>
              </span>
          </li>
      </ul>
  </div>

  <!-- Received By Dropdown -->
  <div *ngIf="column.reByDropdown" class="filterheight overflow-auto">
          
    <ul class="list-group"> 
        <li class="list-group-item filter-header">Filters</li> 
        <li class="list-group-item">
            <span>
                <span class="icon-ic_checkbox" *ngIf="selectAllByType.isChecked" (click)="selectAllByType.isChecked = false;selectAllByFilter(selectAllByType.isChecked)"></span>
                <span class="icon-ic_checkbox_all" *ngIf="!selectAllByType.isChecked" (click)="selectAllByType.isChecked = true;selectAllByFilter(selectAllByType.isChecked)"></span>
                <span class="ml-2" (click)="selectAllByType.isChecked = !selectAllByType.isChecked; selectAllByFilter(selectAllByType.isChecked)">All</span>
            </span>
        </li>
        <li class="list-group-item" *ngFor="let tyarray of reByArray">
            <span class="csr">
                <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(reByArray,selectAllByType,tyarray.isCheck)"></span>
                <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(reByArray,selectAllByType,tyarray.isCheck)"></span>
                <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(reByArray,selectAllByType,tyarray.isCheck)">{{tyarray.description}}</span>
            </span>
        </li>
    </ul>
</div>

  <!--Buttons-->
  <!--Reset-->
  <!-- <div class="button-section"> -->
  <div class="d-flex justify-content-between mx-2 mt-3 mb-3">
    <button (click)="resetEvents()" class="button sm" type="button">
      Cancel
    </button>
    <button (click)="onFilterApply(column)" class="button blue smblue" style="float: right;" type="button">
      Apply
    </button>
  </div>
  <!-- </div> -->
  <!-- <div class="button" (click)="resetEvents(column)"><span>Cancel</span></div> -->
  <!--Apply-->
  <!-- <div class="button blue" (click)="onFilterApply(column)"><span>Apply</span></div> -->
  